import Button from '@/components/Button';
import Checkbox from '@/components/Checkbox';
import Icon from '@/components/Icon';
import { Portal } from '@/components/Portal';
import { websiteEnv } from '@/constants/website-env';
import { generateUrl } from '@/util/imageUtils';
import { Form } from 'informed';
import { useMemo } from 'react';
import { X as CloseIcon } from 'react-feather';
import classes from './mobileFilterModal.module.css';
import useMobileFilterModal from './useMobileFilterModal';

const getStyle = item => {
  if (item.type === 'ColorSwatchData') {
    return {
      backgroundColor: item.rgb,
    };
  } else if (item.type === 'ImageSwatchData') {
    const imagePath = generateUrl(item.thumbnail, 'image-swatch')(25);

    return {
      display: 'block',
      height: '25px',
      width: '25px',
      backgroundSize: '100%',
      backgroundImage: `url("${imagePath}")`,
    };
  }

  return {};
};

const MobileFilterModal = props => {
  const { isOpen, onClose, colors, categories } = props;

  const talonProps = useMobileFilterModal(props);

  const {
    handleClose,
    activeFilter,
    setActiveFilter,
    handleReset,
    applyFilters,
    selectedColorIds,
    setSelectedColorIds,
    selectedCategoryId,
    setSelectedCategoryId,
  } = talonProps;

  const modalClass = isOpen ? classes.root_open : classes.root;

  const filtersList = useMemo(() => {
    return (
      <>
        <li className={activeFilter === 'category' ? classes.filterBlockActive : classes.filterBlock}>
          <button
            type='button'
            className={classes.triggerButton}
            onClick={() => {
              setActiveFilter('category');
            }}
          >
            <span className={classes.buttonLabel}>Category</span>
          </button>
          {activeFilter === 'category' && (
            <Form className={classes.list}>
              <ul>
                <li
                  onClick={() => {
                    setSelectedCategoryId('');
                  }}
                >
                  <Checkbox
                    field={`All`}
                    fieldValue={selectedCategoryId === ''}
                    label='All'
                  />
                </li>
                {categories.map(category => {
                  return (
                    <li
                      key={category.ids}
                      className={classes.label}
                      onClick={() => {
                        setSelectedCategoryId(category.ids);
                      }}
                    >
                      <Checkbox
                        field={category.label}
                        fieldValue={selectedCategoryId === category.ids}
                        label={category.label}
                      />
                    </li>
                  );
                })}
              </ul>
            </Form>
          )}
        </li>
        <li className={activeFilter === 'color' ? classes.filterBlockActive : classes.filterBlock}>
          <button
            type='button'
            className={classes.triggerButton}
            onClick={() => {
              setActiveFilter('color');
            }}
          >
            <span className={classes.buttonLabel}>{websiteEnv.isUnitedKingdom ? 'Colour' : 'Color'}</span>
          </button>
          {activeFilter === 'color' && (
            <Form className={classes.list}>
              <ul>
                {colors.map(color => {
                  return (
                    <li
                      key={color.ids}
                      className={classes.label}
                      onClick={() => {
                        setSelectedColorIds(color.ids);
                      }}
                    >
                      <div
                        className={selectedColorIds === color.ids ? classes.colorBlockActive : classes.colorBlock}
                        style={getStyle(color)}
                      />
                      <span>
                        {websiteEnv.isUnitedKingdom && color.label === 'Multi Color' ? 'Multicolour' : color.label}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </Form>
          )}
        </li>
      </>
    );
  }, [activeFilter, categories, colors, selectedCategoryId, selectedColorIds]);

  if (!isOpen) {
    return null;
  }

  return (
    <Portal>
      <aside className={modalClass}>
        <div className={classes.body}>
          <div className={classes.header}>
            <h2 className={classes.headerTitle}>Filters</h2>
            <button
              onClick={handleClose}
              aria-disabled={false}
              aria-label='Close filters popup.'
            >
              <Icon src={CloseIcon} />
            </button>
          </div>

          <ul className={classes.blocks}>{filtersList}</ul>
        </div>
        <div className={classes.footer}>
          <Button
            onClick={handleReset}
            className={classes.resetButton}
          >
            RESET
          </Button>

          <Button
            onClick={applyFilters}
            priority='high'
            className={classes.applyButton}
          >
            DONE
          </Button>
        </div>
      </aside>
    </Portal>
  );
};

export default MobileFilterModal;
